import { z } from "zod";

export const postMedicalConditionSchema = z.object({
  diagnosisName: z
    .string()
    .min(1, { message: "Symptom is required" })
    .max(100, { message: "Must be 250 characters or fewer" }),
  diagnosisDescription: z
    .string()
    .min(1, { message: "Description is required" })
    .max(250, { message: "Must be 250 characters or fewer" }),
  tags: z.array(z.string()).nullish(),
  medicalConditionStage: z
    .string()
    .min(1, { message: "Medical Condition stage is required" }),
  startDate: z.optional(
    z.union([
      z.number({ message: "Symptom End Date Required" }),
      z.string({ message: "Symptom End Date Required" }),
      z.date({ message: "Symptom End Date Required" }),
    ])
  ),
});
